import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalRulesComponent } from './rules-global/global-rules.component';
import { SchoolProgramRulesComponent } from './school-program-rules.component';
import { RulesComponent } from '../rules/rules.component';

const routes: Routes = [
  {
    path: '',
    component: SchoolProgramRulesComponent,
    children: [
      {
        path: '',
        component: GlobalRulesComponent
      },
      {
        path: 'rules',
        component: RulesComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SchoolProgramRulesRoutingModule { }
